import { OrderPageState } from './OrderPageState';
import TTLLocalStorage from '../../common/TTLLocalStorage';

export const ORDER_PAGE_STATE_LOCAL_STORAGE_KEY = 'order-page-state';

const getOrderPageStateStorageKey = (orderPageId: string): string => {
  return `${ORDER_PAGE_STATE_LOCAL_STORAGE_KEY}-${orderPageId}`;
};

export const getOrderPageStateFromLocalStorage = (orderPageId: string): OrderPageState | null => {
  const key = getOrderPageStateStorageKey(orderPageId);
  return TTLLocalStorage.getItem(key);
};

export const setOrderPageStateToLocalStorage = (orderPageId: string, state: OrderPageState): void => {
  const key = getOrderPageStateStorageKey(orderPageId);
  TTLLocalStorage.setItem(key, state, 10 * 60 * 1000); // 10 minutes
};

export const clearOrderPageStateFromLocalStorage = (): void => {
  TTLLocalStorage.removeByPrefix(ORDER_PAGE_STATE_LOCAL_STORAGE_KEY);
};

export const getOrderPageStateTTLLeft = (orderPageId: string): number => {
  const key = getOrderPageStateStorageKey(orderPageId);
  return TTLLocalStorage.getTTLLeft(key) || 0;
};
